import { axios } from "@/utils/request";
// 里程碑
export const LichengbeiDataList=()=>axios.get('/jeecg-system/frontend/milestone/list_all')